<template>
    <div>
      <hamburger :path="$route.path" />
      <div class="bg-secondary p-3 mb-5 rounded-lg flex justify-between items-center">
          <h1 class="text-lg font-semibold uppercase">Song Edit</h1>
      </div>
      <song-form :id="$route.params.id"/>
    </div>
</template>

<script>
import songForm from '~/components/common/form/song.vue'
import hamburger from '~/components/common/hamburger.vue'

export default {
    name: "SongEditPage",
    components: { hamburger, songForm },
    layout: 'UserNavigation',
    transition: "slide-bottom",
}
</script>